import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color:${({ theme }) => theme.colors.primary} ;
    padding: 10px 20px;
    border-radius: 10px;
    margin-bottom: 10px;
`;

export const MontagemTitle = styled.h5`
    color: ${({ theme }) => theme.colors.white};
`;
